import React, { useState } from "react";
import CardView from "../../../components/common/CardView";

const PerformanceTable = (props) => {
  const isMobile = window.innerWidth <= 768;
  const tableHead = props.tableHeader;

  const legendData = (title, data) => {
    return (
      <>
        <tr className="table-light">
          <th className="p-3"></th>
          <th className="p-3"></th>
        </tr>
        <tr>
          <td className="p-3">{title}</td>
          <td className="p-3">{data}</td>
        </tr>
      </>
    );
  };

  return (
    <>
      {/* Responsive Table Wrapper */}
      <div
        className="table-responsive position-relative p-0"
        style={{ overflowX: "auto", maxWidth: "100vw" }}
      >
        <table className="table mt-4 table-bordered text-center table-hover">
          <thead className="table-active">
            <tr>
              <th></th>
              <th></th>
              <th colSpan={1}>Success Indicators</th>

              {tableHead.includes("Allotted Budget") && (
                <>
                  <th></th>
                  <th></th>
                </>
              )}
              {tableHead.includes("%Distribution") && (
                <>
                  <th></th>
                  <th></th>
                </>
              )}
              <th colSpan={4}>
                Rating{" "}
                <i
                  className="bi bi-info-circle-fill"
                  onClick={() => props.handleRatingClick()}
                  style={{ cursor: "pointer" }}
                />
              </th>
              <th></th>
              {tableHead.includes("%Distribution") && (
                <>
                  <th></th>
                </>
              )}
              <th className="position-sticky end-0"></th>
            </tr>
          </thead>
          <tbody>
            <tr className="table-active">
              {props.tableHeader.map((head, index) => (
                <th key={index}>{head}</th>
              ))}
            </tr>
            {props?.formulaHeader && (
              <tr className="table-active">
                {props.formulaHeader.map((head, index) => (
                  <th key={index}>{head}</th>
                ))}
              </tr>
            )}
            {/* Data Rows */}
            {props.object.length > 0 ? (
              props.object.map((item, index) => {
                return (
                  <tr key={index} style={{ verticalAlign: "middle" }}>
                    <td>{index + 1}</td>
                    {props?.tableBody?.map((key, index) => {
                      console.log("ITEM :", key);
                      return (
                        <td key={index} style={{ overflow: "hidden" }}>
                          {key === "average" ? (
                            item[key]?.toFixed(2)
                          ) : (
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  key === "distribution"
                                    ? `${item[key]}%`
                                    : item[key]
                                        .toString()
                                        .replace(/\n/g, "<br />"),
                              }}
                            />
                          )}
                        </td>
                      );
                    })}
                    <td className="position-sticky end-0">
                      <div className="d-flex gap-1">
                        <button
                          type="button"
                          disabled={props.disabled}
                          className="btn btn-primary bi bi-pencil-square"
                          onClick={() => props.handleEditData(item, index)}
                        ></button>

                        <button
                          type="button"
                          disabled={props.disabled}
                          className="btn btn-danger bi bi-trash"
                          onClick={() => props.handleTrashData(index)}
                        ></button>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={tableHead ? "14" : "10"}>
                  <div className="d-flex align-items-center justify-content-center pt-2">
                    <img width="120" src={"/noData.svg"} alt="No Data" />
                  </div>
                  <p className="text-center">No Data</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal for Legend */}
      {props.isRating && (
        <>
          <div
            className="w-100 h-100 position-fixed end-0 start-0 top-0 overflow-y-auto d-flex justify-content-center align-items-center"
            style={{
              zIndex: 1051,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
            }}
          >
            <div
              className="w-100 d-flex column align-items-center"
              style={{
                maxHeight: "99%",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  width: isMobile ? "98%" : "50rem",
                }}
              >
                <CardView style={{ padding: 0 }}>
                  <h5 className="ms-3 mt-4 fw-bold">Legend</h5>
                  <div className="p-3">
                    <table
                      className="table table-bordered"
                      style={{ fontSize: "15px" }}
                    >
                      <tbody>
                        <tr className="table-light">
                          <th className="p-3">Category</th>
                          <th className="p-3">Definition</th>
                        </tr>
                        {legendData(
                          "Effectiveness/Quality",
                          `The extent to which actual performance compares with
                            targeted performance.`
                        )}
                        {legendData(
                          "Efficiency",
                          `The extent to which time or resources is used for
                            the intended task or purpose.`
                        )}
                        {legendData(
                          "Timeliness",
                          `Measures whether the deliverable was done on time.`
                        )}
                        {legendData(
                          "Note",
                          `When entering Quantity, Efficiency, and Timeliness,
                            if you don't have anything to input in those fields,
                            kindly leave them blank.`
                        )}
                      </tbody>
                    </table>
                  </div>
                  <hr />
                  <div className="ms-auto pb-3 pe-3">
                    <button
                      className="btn btn-primary"
                      onClick={() => props.handleRatingClick()}
                    >
                      Okay
                    </button>
                  </div>
                </CardView>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PerformanceTable;
